import { config, httpHelper } from 'modules/common/helpers';

const BASE_URL = config.beUrl;

export default {
  getVoucherInfo,
};

function getVoucherInfo(code: string, withoutError: boolean) {
  return httpHelper.get(
    `${BASE_URL}/voucher/${code}`,
    {},
    undefined,
    withoutError
  );
}
